import React from "react";
import { PackageOpen, PackageSearch, RefreshCw, SearchX } from "lucide-react";

// Rich empty state rendered in place of the table body whenever the vendor
// has no orders (or none match the current filters).
const OrdersEmptyState = ({ hasActiveFilters, onClearFilters, onRefresh }) => {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center sm:py-20">
      <div className="relative mb-6">
        <div className="absolute inset-0 bg-gradient-to-br from-[#FF6C6C]/10 to-purple-500/10 rounded-full blur-2xl" />
        <div className="flex relative justify-center items-center w-24 h-24 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl border border-gray-200 shadow-sm">
          {hasActiveFilters ? (
            <SearchX className="w-10 h-10 text-gray-400" />
          ) : (
            <PackageOpen className="w-10 h-10 text-gray-400" />
          )}
        </div>
        <div className="flex absolute -top-1.5 -right-1.5 justify-center items-center w-8 h-8 bg-white rounded-full border border-gray-100 shadow-md">
          <PackageSearch className="w-4 h-4 text-[#FF6C6C]" />
        </div>
      </div>

      <h3 className="mb-2 text-lg font-semibold text-gray-900">
        {hasActiveFilters ? "No orders match your filters" : "No orders yet"}
      </h3>
      <p className="max-w-sm text-sm text-gray-500">
        {hasActiveFilters
          ? "Try adjusting or clearing your search and filters to see more results."
          : "When customers purchase your deals, their orders will show up here in real time — nothing to do for now."}
      </p>

      <div className="flex gap-3 items-center mt-6">
        {hasActiveFilters && (
          <button
            onClick={onClearFilters}
            className="inline-flex items-center px-4 py-2.5 text-sm font-medium text-gray-700 bg-white rounded-xl border border-gray-200 transition-colors hover:bg-gray-50"
          >
            Clear Filters
          </button>
        )}
        <button
          onClick={onRefresh}
          className="inline-flex items-center px-4 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-[#FF6C6C] to-[#FF8F8F] rounded-xl shadow-sm transition-all hover:opacity-90 hover:shadow-md"
        >
          <RefreshCw className="mr-2 w-4 h-4" />
          Refresh
        </button>
      </div>
    </div>
  );
};

export default OrdersEmptyState;
